import { Skeleton, StagedIcon, Typography } from "@packages/ds";
import styled from "styled-components";

import { IconControl } from "ds/Button";
import { semiBoldAlias } from "Libs/theme";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;
  color: var(--section-ebony-light-color, var(--ebony-light));
`;

export const GridWrapper = styled.div`
  width: 100%;
  margin-top: 0 !important;
  padding: 22px 0 32px 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 16px;
`;

export const ItemWrapper = styled.div`
  width: 100%;
  .label {
    margin-top: 0;
    margin-bottom: 16px;
  }
  .subtext {
    margin-top: 0;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled(Typography.Title)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Wizard = styled.div`
  display: flex;
  margin: 16px 0 0 0;
`;

export const Live = styled.span`
  display: inline-block;
  background-color: var(
    --section-color-primary-100-background-color,
    var(--color-primary-100)
  );
  color: var(--section-color-primary-600-color, var(--color-primary-600));
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  padding: 0 8px;
  ${semiBoldAlias()};
  border-radius: 2px;
  margin-left: 4px;
`;

export const Time = styled.div`
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 8px;
  position: relative;
  ${semiBoldAlias()};
`;

export const Status = styled.div<{ status?: string }>`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 15px;
  line-height: 18px;
  ${semiBoldAlias()};
  text-transform: capitalize;

  &::after {
    content: "";
    display: inline-block;
    margin-left: 12px;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    background: ${props => {
      switch (props.status) {
        case "active":
          return "var(--section-java-background-color,var(--java))";
        case "dirty":
        case "disabled":
          return "#ff8359";
        case "inactive":
          return "#98a0ab";
        case "paused":
          return "transparent";
        default:
          return "var(--section-java-background-color,var(--java))";
      }
    }};
  }
`;

export const HttpAccessStatus = styled(Status)<{ isProduction?: boolean }>`
  &::after {
    background: ${({ status, isProduction }) => {
      const java = "var(--section-java-background-color,var(--java))";
      const fire = "var(--section-fire-color,var(--fire))";

      switch (status) {
        case "active":
          return isProduction ? fire : java;
        case "dirty":
        case "disabled":
          return isProduction ? java : fire;
        default:
          return isProduction ? fire : java;
      }
    }};
  }
`;

export const Label = styled.div`
  display: flex;
  font-size: 13px;
  line-height: 16px;
  color: var(--section-granite-color, var(--granite));
  align-items: center;
  ${semiBoldAlias()};
  .info-dialog {
    margin-bottom: -2px;
  }
`;

export const Value = styled.div`
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 4px;
  ${semiBoldAlias()};
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
  position: relative;
`;

export const NoUrl = styled.div`
  display: flex;
  width: calc(100% + 48px);
  height: 48px;
  box-sizing: border-box;
  margin: 0 -24px -24px -24px;
  padding: 12px 16px;
  background-color: var(
    --no-env-section-background-color,
    var(--section-ice-background-color, var(--ice))
  );
  font-size: 14px;
  line-height: 24px;
  ${semiBoldAlias()};
  color: var(--section-slate-color, var(--slate));
`;

export const InactiveMessage = styled.div`
  margin-left: 16px;
  margin-right: 8px;
`;

export const IdRegion = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
  min-height: 32px;
  ${semiBoldAlias()};
  color: var(
    --id-region-section-color,
    var(--section-granite-color, var(--granite))
  );
`;

export const Environment = styled.span`
  display: inline-block;
  background-color: var(
    --section-color-neutral-300-background-color,
    var(--color-neutral-300)
  );
  color: var(--section-slate-color, var(--slate));
  font-size: 12px;
  line-height: 24px;
  height: 24px;
  padding: 0 8px;
  ${semiBoldAlias()};
  border-radius: 2px;
`;

export const EnvLiveWrapper = styled.div`
  display: flex;
`;

export const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const ConfigureResourcesButtonWrapper = styled.div`
  position: absolute;
  right: 15px;
  top: -2px;
`;

export const LayoutSkeleton = styled(Skeleton)`
  :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Row = styled(Skeleton.Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  padding-right: 32px;
`;

export const InfoLinkContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const IconControlRegion = styled(IconControl)`
  margin-right: 8px;
  color: var(--color-java-600);
`;

export const ContentWrapper = styled.div`
  width: 268px;
`;

export const TitleIconWrapper = styled.div`
  display: flex;
  align-items: end;
`;

export const Staged = styled(StagedIcon)`
  margin-left: 8px;
`;
